export interface ICssProperty {
    property: string;
    value: string | null;
    priority?: "important" | null;
}

export interface ICssPropertiesObject {
    [propName: string]: string | null | undefined;
}

export class CssProperties {

    public readonly data: ICssProperty[] = [];

    public push(...items: ICssProperty[]): CssProperties {
        this.data.push(...items);
        return this;
    }

    public add(property: string, value: string, priority?: "important" | null): CssProperties {
        this.data.push({ property, value, priority });
        return this;
    }

    public addObj(props: ICssPropertiesObject): CssProperties {
        for (const propName in props) {
            this.tryAdd(propName, props[propName]);
        }
        return this;
    }

    public tryAdd(property: string, value: string | undefined | null, priority?: "important" | null): CssProperties {
        if (value) this.data.push({ property, value, priority });
        return this;
    }

    public tryAddAll(properties: string[], value: string | undefined | null, priority?: "important" | null): CssProperties {
        if (value) {
            properties.forEach(property => this.data.push({ property, value, priority }));
        }
        return this;
    }

    public static format(prop: ICssProperty): string {
        if (prop.priority) return `${prop.property}:${prop.value} !${prop.priority}`;
        return `${prop.property}:${prop.value}`;
    }

}

export class CssSize {

    private static readonly dimentions = ["rem", "em", "pt", "px", "%"];

    constructor(
        public size: number,
        public dim: string) {
    }

    public toString(): string {
        if (this.size === 0)
            return "0";
        return `${this.size}${this.dim}`;
    }

    public static parse(css: string | null | undefined): CssSize | null {
        if (!css) return null;
        let dim: string | null = null;
        let size: number = NaN;
        for (const d of this.dimentions) {
            if (css.endsWith(d)) {
                dim = d;
                size = parseFloat(css.replace(d, ""));
                break;
            }
        }

        if (dim && !isNaN(size)) return new CssSize(size, dim);
        return null;
    }

    // parse css flex value: 1 1 50px;
    public static parseFlexCss(css: string | null): CssSize | null {
        if (!css) return null;
        const parts = css.split(" ");
        if (parts.length !== 3) return null;
        return this.parse(parts[2]);
    }

}
